export enum AmericanFootballSackAttribute {
  Assisted = 649,
  // TODO: this number is wrong, update it when it's introduced in api
  NotAssisted = 711,
}
